import { ActionTypes } from "../../constants/action-types";

const initialState = {
    dashboard: [],
    is_dashboard: false
};


export const dashboardReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case ActionTypes.SET_DASHBOARD:
            return {
                ...state,
                is_dashboard: true,
                dashboard: payload
            };

        case ActionTypes.RESET_STORE:
            return {
                ...(state = initialState),
            };
        default:
            return state;
    }
};
